// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Film } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconFilm(props: any) {
    return <IconBase icon={Film} {...props} />
  }

  export default IconFilm
  